import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ 
    "editNameAr", "editNameEn", "editMainContact", "editSecondContact", 
    "editAddressAr", "editAddressEn", "editEmail", "editOriginalEmail", "editMaxProcedures", "editId",
    "inviteAddressAr", "inviteAddressEn", "inviteEmail", "inviteId",
    "proceduresModal", "contractsModal", "proceduresLoad", "contractsLoad", "proceduresContent", "contractsContent",
    "procedureDoctorId", "contractDoctorId",
    "setPasswordNameAr", "setPasswordNameEn", "setPasswordEmail", "setPasswordId", 
    "setPasswordPassword", "setPasswordConfirmation", "activationNotice"
  ]

  connect() {
    // Initialize datatables if needed or rely on existing logic if it's not broken. 
    // For now, we focus on modals.
  }

  edit(event) {
    event.preventDefault()
    const data = event.params
    
    this.editNameArTarget.value = data.nameAr
    this.editNameEnTarget.value = data.nameEn
    this.editMainContactTarget.value = data.mainContact
    this.editSecondContactTarget.value = data.secondContact
    this.editAddressArTarget.value = data.addressAr
    this.editAddressEnTarget.value = data.addressEn
    this.editEmailTarget.value = data.email
    this.editOriginalEmailTarget.value = data.email
    this.editMaxProceduresTarget.value = data.maxProcedures
    this.editIdTarget.value = data.id
    
    $('#edit_doctor_detail').modal('show')
  }

  invite(event) {
    event.preventDefault()
    const data = event.params
    
    this.inviteAddressArTarget.value = data.nameAr
    this.inviteAddressEnTarget.value = data.nameEn
    this.inviteEmailTarget.innerHTML = `<label>${data.email}</label>`
    this.inviteIdTarget.value = data.id
    
    $('#invite_doctor').modal('show')
  }

  procedures(event) {
    event.preventDefault()
    const doctorId = event.params.id
    
    // Reset state
    this.proceduresLoadTarget.style.display = "block"
    this.proceduresContentTarget.style.display = "none"
    $(".proc_check").prop('checked', false)
    this.procedureDoctorIdTarget.value = doctorId
    
    $('#doctor_procedures_detail').modal('show')
    
    $.ajax({
      type: "get",
      url: "/admin/doctor_procedure/get",
      dataType: "json",
      beforeSend: function(xhr) {
        xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'))
      },
      data: { doctor_id: doctorId },
      success: (result) => {
        this.proceduresLoadTarget.style.display = "none"
        this.proceduresContentTarget.style.display = "block"
        
        for(var i=0; i<result.procedures.length; i++){
          $("#procedures_status_"+result.procedures[i].procedure_code).prop('checked', true)
        }
      }
    })
  }

  contracts(event) {
    event.preventDefault()
    const doctorId = event.params.id
    
    // Reset state
    this.contractsLoadTarget.style.display = "block"
    this.contractsContentTarget.style.display = "none"
    $(".cont_check").prop('checked', false)
    this.contractDoctorIdTarget.value = doctorId
    
    $('#doctor_contracts_detail').modal('show')
    
    $.ajax({
      type: "get",
      url: "/admin/doctor_contract/get",
      dataType: "json",
      beforeSend: function(xhr) {
        xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'))
      },
      data: { doctor_id: doctorId },
      success: (result) => {
        this.contractsLoadTarget.style.display = "none"
        this.contractsContentTarget.style.display = "block"
        
        for(var i=0; i<result.contracts.length; i++){
          $("#contract_status_"+result.contracts[i].contract_code).prop('checked', true)
          // Set contractual discount value if it exists
          if(result.contracts[i].contractual_discount !== undefined && result.contracts[i].contractual_discount !== null) {
            $("#contractual_discount_"+result.contracts[i].contract_code).val(result.contracts[i].contractual_discount)
          }
        }
      }
    })
  }
  
  toggleAllProcedures(event) {
    if(event.target.checked) {
      $(".check").prop('checked', true)
    } else {
      $(".check").prop('checked', false)
    }
  }

  toggleAllContracts(event) {
    if(event.target.checked) {
      $(".cont_check").prop('checked', true)
    } else {
      $(".cont_check").prop('checked', false)
    }
  }

  setPassword(event) {
    event.preventDefault()
    const data = event.params
    
    this.setPasswordNameArTarget.value = data.nameAr
    this.setPasswordNameEnTarget.value = data.nameEn
    this.setPasswordEmailTarget.value = data.email
    this.setPasswordIdTarget.value = data.id
    this.setPasswordPasswordTarget.value = ''
    this.setPasswordConfirmationTarget.value = ''
    
    // Show activation notice if account is not activated
    if (data.activated === false || data.activated === 'false') {
      this.activationNoticeTarget.style.display = 'block'
    } else {
      this.activationNoticeTarget.style.display = 'none'
    }
    
    $('#set_password_doctor').modal('show')
  }
}
